
































































































import {Component, Prop, Watch, Vue} from 'vue-property-decorator';
import Draggable from 'vuedraggable';
import CSimpleTable from '@/components/base/table/CSimpleTable.vue';

@Component({
    inheritAttrs: false,
    components: {
        CSimpleTable,
        Draggable,
    },
})
export default class CTable extends Vue {
    @Prop({required: true}) value!: any[];
    @Prop() addData!: {[key: string]: any};
    @Prop() title!: string;
    @Prop({default: false, type: Boolean}) noEditRequest!: boolean;
    @Prop({default: false, type: Boolean}) draggable!: boolean;
    @Prop({type: Boolean, default: false}) readonly!: boolean;
    @Prop() itemDeleteBtnIsDisabled!: Function;
    @Prop() onCopyFn!: Function;

    private items: any[] = [];

    @Watch('value', {immediate: true, deep: true})
    onValueChange(value: any[]) {
        this.items = value;
    }
    @Watch('items', {deep: true})
    onItemsChange(value: any[]) {
        this.$emit('input', this.items);
    }

    onAdd() {
        this.items.push(Object.assign({}, this.addData));
    }
    onDeleteAll() {
        this.items = [];
    }
    onDelete(item: any) {
        this.items = this.items.filter(el => el != item);
    }
    onCopy(item: any) {
        let data;
        if (this.onCopyFn) {
            data = this.onCopyFn(item);
        } else data = Object.assign({}, item);
        this.items.push(data);
    }
}
